import { History } from 'lucide-react';
import { useNavigate } from 'react-router';

import { useEstadoTabela } from '@/lib/estado-tabela';
import { EstadoVazio } from '@/ui/components/estado-vazio';
import { TabelaPaginada } from '@/ui/components/tabela-paginada';
import { CabecalhoPagina } from '@/ui/patterns/cabecalho-pagina';
import { PaginaLista } from '@/ui/patterns/pagina-lista';
import { Migalhas } from '@/ui/shell/migalhas';

import { useLotes } from './api';
import { colunasLotes } from './colunas-lotes';

const TABELA = {
  chave: 'historico-importacoes',
  campos: ['criadoEm', 'totalItens'] as const,
  padrao: { ordenarPor: 'criadoEm', ordem: 'desc' },
} as const;

/** Todos os envios, do mais novo para o mais antigo; a linha abre o lote com cada arquivo. */
export function PaginaHistorico() {
  const navegar = useNavigate();
  const tabela = useEstadoTabela(TABELA);
  const lotes = useLotes({
    pagina: tabela.pagina,
    porPagina: tabela.porPagina,
    ordenarPor: tabela.ordenarPor,
    ordem: tabela.ordem,
  });
  return (
    <PaginaLista
      cabecalho={
        <div className="grid gap-3">
          <Migalhas
            itens={[{ rotulo: 'Importar notas', para: '/importacao' }, { rotulo: 'Histórico' }]}
          />
          <CabecalhoPagina
            titulo="Histórico de importações"
            descricao="Cada envio com o que entrou e o que precisa de atenção. Abra um para ver arquivo por arquivo."
          />
        </div>
      }
      lista={
        <TabelaPaginada
          rotulo="Envios"
          className="min-h-80 flex-1"
          colunas={colunasLotes}
          dados={lotes.data?.items ?? []}
          total={lotes.data?.total ?? 0}
          pagina={tabela.pagina}
          porPagina={tabela.porPagina}
          aoMudarPagina={tabela.irParaPagina}
          aoMudarPorPagina={tabela.mudarPorPagina}
          ordenacao={tabela.ordenacao}
          aoOrdenar={tabela.ordenar}
          idLinha={(lote) => lote.id}
          carregando={lotes.isPending}
          atualizando={lotes.isPlaceholderData}
          aoAbrir={(lote) => void navegar(`/importacao/${lote.id}`)}
          vazio={
            <EstadoVazio
              icone={<History />}
              titulo="Nenhum envio ainda"
              texto="Importe XMLs, ZIPs ou o relatório da SEFAZ em Importar notas."
            />
          }
        />
      }
    />
  );
}
